import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Line, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

@Component({
	extends: Line,
	mixins: [reactiveProp]
})
export default class LineChart extends Vue {
	@Prop() options!: {};

	mounted() {
		// this.chartData is created in the mixin.
		// If you want to pass options please create a local options object
		// @ts-ignore
		this.renderChart(this.chartData, this.options);
	}

	@Watch('options')
	onOptionsChanged(): void {
		// this.chartData is created in the mixin.
		// If you want to pass options please create a local options object
		// @ts-ignore
		this.renderChart(this.chartData, this.options);
	}
}
